<template>

<core-panel>

	<template v-slot:head>

		<h1>{{ title }}</h1>

		<p>Games in this region of {{ your }} universe, sorted by play count.</p>

	</template>

	<template v-slot:body>

		<app-game v-for="(item, index) in games" :item="gameItem(item)" :key="index" :show-plays-text="true" v-on:click.native="goToGame(item.g)">

			<template v-slot:below>
				<div class="universe-tags">
					<span class="universe-tag" v-for="tag in gameTags(item)" :key="tag" :data-theme="tag">{{ tag }}</span>
				</div>
			</template>

		</app-game>

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'universe',
			params: ['segment'],
			games: []
		}

	},

	computed: {

		your: function() {

			return this.$store.getters['context/your']

		},

		title: function() {

			return (this.data && this.data.title) ? this.data.title : 'Universe'

		}

	},

	methods: {

		response: function(json) {

			this.games = json.universeList || []

		},

		gameItem: function(item) {

			return {
				id: item.g,
				plays: item.p || 0,
				rating: item.r || 0
			}

		},

		gameTags: function(item) {

			var tags = []
			if (item.f & 1) tags.push('Own')
			if (item.f & 2) tags.push('Prev. Owned')
			if (item.f & 4) tags.push('Played')
			if (item.f & 8) tags.push('Rated')
			if (item.f & 16) tags.push('Wishlisted')
			return tags

		},

		goToGame: function(id) {

			this.$router.push({ name: 'InsightsGame', params: { game: id } })
			this.$pubsub.$emit('panel.close')

		}

	}

}

</script>

<style scoped>

.universe-tags {
	display: flex;
	gap: 4px;
	margin-top: 2px;
}

.universe-tag {
	font-size: 10px;
	color: #fff;
	padding: 2px 5px;
	border-radius: 3px;
	font-weight: 500;
	line-height: 12px;
}

.universe-tag[data-theme="Own"] { background-color: #4881bb; }
.universe-tag[data-theme="Prev. Owned"] { background-color: #7a5fbf; }
.universe-tag[data-theme="Played"] { background-color: #2FC482; }
.universe-tag[data-theme="Rated"] { background-color: #f5a623; }
.universe-tag[data-theme="Wishlisted"] { background-color: #e85d75; }

</style>
